export default Object.freeze({
  Transient: 0,
  Functional: 1,
  InvalidFile: 2,
  CorruptedFile: 3,
  ResourceLimitExceeded: 4,
  Unexpected: 5,
});
